export const ACL_DETAIL = "detail"
export const ACL_CREATE = "create"
export const ACL_READ = "read"
export const ACL_UPDATE = "update"
export const ACL_LOCK_UNLOCK = "lock or unlock"
export const ACL_DELETE = "delete"
export const ACL_VERIFY = "verify"
export const ACL_APPROVE = "approve"
export const ACL_DASHBOARD = "view dashboard"
export const ACL_RESET_PASSWORD = "reset password"
export const ACL_DELETE_DUPLICATE_AND_REACTIVE = "delete duplicate and reactive"

export const ACL_SUBJECT_DASHBOARD = "Dashboard"
export const ACL_SUBJECT_CATEGORY = "Category"
export const ACL_SUBJECT_USER = "User"
export const ACL_SUBJECT_ROLE = "Role"
export const ACL_SUBJECT_ORGANIZATION = "Organization"
export const ACL_SUBJECT_WAIT_ORGANIZATION = "Wait Organization"
export const ACL_SUBJECT_PERSON = "Person"
export const ACL_SUBJECT_IDENTIFICATION = "Identification"
export const ACL_SUBJECT_CONFIGURATION = "Configuration"
export const ACL_SUBJECT_APPLICATION = "Application"
export const ACL_SUBJECT_HISTORY_ACTIVITY = "History Activity"
export const ACL_SUBJECT_HISTORY_LOGIN = "History Login/logout"
export const ACL_SUBJECT_REPORT_PERSON = "Report Person"
export const ACL_SUBJECT_REPORT_ORGANIZATION = "Report Organization"
